var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"period"},[_c('ul',_vm._l((_vm.items),function(item,index){return _c('li',{key:item,staticClass:"datesList",class:{ edgeFirst: index === 0,
                          edgeLast: index === _vm.items.length-1,
                          active:index === _vm.selected },on:{"click":function($event){_vm.selected = index}}},[_vm._v("\n                "+_vm._s(item)+"\n        ")])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30070447","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/filters/Period.vue
// module id = null
// module chunks = 